module.exports = __webpack_public_path__ + "static/media/UK-Glasgow.97a63ffc.png";